export const PayrollActionTypes = {
    LOGOUT: 'LOGOUT',
    COMMON_ERROR: 'COMMON_ERROR',

    NEW_TAX_RULE_REQUEST: 'NEW_TAX_RULE_REQUEST',
    NEW_TAX_RULE_REQUEST_SUCCESS: 'NEW_TAX_RULE_REQUEST_SUCCESS',
    NEW_TAX_RULE_REQUEST_ERROR: 'NEW_TAX_RULE_REQUEST_ERROR',
    NEW_TAX_RULE_REQUEST_STATUS: 'NEW_TAX_RULE_REQUEST_STATUS',

    TAX_RULE_LIST_REQUEST: 'TAX_RULE_LIST_REQUEST',
    TAX_RULE_LIST_REQUEST_SUCCESS: 'TAX_RULE_LIST_REQUEST_SUCCESS',
    TAX_RULE_LIST_REQUEST_ERROR: 'TAX_RULE_LIST_REQUEST_ERROR',

    UPDATE_TAX_RULE_REQUEST: 'UPDATE_TAX_RULE_REQUEST',
    UPDATE_TAX_RULE_REQUEST_SUCCESS: 'UPDATE_TAX_RULE_REQUEST_SUCCESS',
    UPDATE_TAX_RULE_REQUEST_ERROR: 'UPDATE_TAX_RULE_REQUEST_ERROR',
    UPDATE_TAX_RULE_REQUEST_STATUS: 'UPDATE_TAX_RULE_REQUEST_STATUS',

    PROVISIONAL_PAYSLIP_REQUEST: 'PROVISIONAL_PAYSLIP_REQUEST',
    PROVISIONAL_PAYSLIP_REQUEST_SUCCESS: 'PROVISIONAL_PAYSLIP_REQUEST_SUCCESS',
    PROVISIONAL_PAYSLIP_REQUEST_ERROR: 'PROVISIONAL_PAYSLIP_REQUEST_ERROR',
    PROVISIONAL_PAYSLIP_REQUEST_STATUS: 'PROVISIONAL_PAYSLIP_REQUEST_STATUS',

    NEW_PAYSLIP_LIST_REQUEST: 'NEW_PAYSLIP_LIST_REQUEST',
    NEW_PAYSLIP_LIST_REQUEST_SUCCESS: 'NEW_PAYSLIP_LIST_REQUEST_SUCCESS',
    NEW_PAYSLIP_LIST_REQUEST_ERROR: 'NEW_PAYSLIP_LIST_REQUEST_ERROR',
    NEW_PAYSLIP_LIST_REQUEST_STATUS: 'NEW_PAYSLIP_LIST_REQUEST_STATUS',

    PAYSLIP_LIST_REQUEST: 'PAYSLIP_LIST_REQUEST',
    PAYSLIP_LIST_REQUEST_SUCCESS: 'PAYSLIP_LIST_REQUEST_SUCCESS',
    PAYSLIP_LIST_REQUEST_ERROR: 'PAYSLIP_LIST_REQUEST_ERROR',

    PAYSLIP_DETAIL_REQUEST: 'PAYSLIP_DETAIL_REQUEST',
    PAYSLIP_DETAIL_REQUEST_SUCCESS: 'PAYSLIP_DETAIL_REQUEST_SUCCESS',
    PAYSLIP_DETAIL_REQUEST_ERROR: 'PAYSLIP_DETAIL_REQUEST_ERROR',

    UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST: 'UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST',
    UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_SUCCESS: 'UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_SUCCESS',
    UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_ERROR: 'UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_ERROR',
    UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_STATUS: 'UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_STATUS'
}
